import common from '../language/en/common.json'
import login from '../language/en/login.json'
import search from '../language/en/search.json'
import header from '../language/en/header.json'
import button from '../language/en/button.json'
import home from '../language/en/home.json'
import menu from '../language/en/menu.json'
import share from '../language/en/share.json'
import user from '../language/en/user.json'
import master from '../language/en/master.json'
import warehouse from './en/warehouse.json'
import display from './en/display.json'


export default {
   ...common,
   ...login,
   ...search,
   ...header,
   ...button,
   ...home,
   ...menu,
   ...share,
   ...user,
   ...master,
   ...warehouse,
   ...display
}


// WEBPACK FOOTER //
// ./src/wording/language/en.js